import { isTesting, macroCondition } from '@embroider/macros';
import type { SubscriptionProfileAddress } from 'lumen/models/subscription/profile';

export interface Coords {
  lat: number;
  lng: number;
}

export function isLegacySentinelCoords(
  lat: number | null | undefined,
  lng: number | null | undefined,
): boolean {
  return lat === 0 && lng === 0;
}

export async function geocodeAddress(
  address: SubscriptionProfileAddress | null | undefined,
): Promise<Coords | null> {
  if (macroCondition(isTesting())) {
    return null;
  }

  if (typeof google === 'undefined' || !google.maps?.Geocoder) {
    return null;
  }

  const { street, number, postalCode, cityName, country } = address ?? {};
  const composedAddress = [street, number, postalCode, cityName]
    .filter(Boolean)
    .join(' ');

  if (!composedAddress) {
    return null;
  }

  try {
    const geocoder = new google.maps.Geocoder();
    const result = await geocoder.geocode({
      address: composedAddress,
      componentRestrictions: { country },
    });

    const first = result.results[0];
    if (!first) {
      return null;
    }

    return {
      lat: first.geometry.location.lat(),
      lng: first.geometry.location.lng(),
    };
  } catch {
    return null;
  }
}
